export default __webpack_public_path__ + "static/media/gr.86b37cc4.svg";